// src/lib/fetchWithAuth.ts

export default async function fetchWithAuth(
  input: RequestInfo,
  init: RequestInit = {}
): Promise<Response> {
  const token = localStorage.getItem("adminToken") || localStorage.getItem("authToken");

  const headers = new Headers(init.headers || {});
  
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  // Avoid overriding Content-Type for FormData requests
  if (
    !headers.has("Content-Type") &&
    !(init.body instanceof FormData)
  ) {
    headers.set("Content-Type", "application/json");
  }

  const response = await fetch(input, {
    ...init,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("adminToken");
    window.location.href = "/login"; // Adjust if you want "/admin/login"
  }

  return response;
}
